import { MemberCenterPage } from './MemberCenterPage';
export default MemberCenterPage;